import { AmountValue, AmountValueProps as AmountValuePropsDS } from '@billy/design-system'

import { getCurrentLocale } from '../../utils'

export type AmountValueLocalizedProps = Omit<AmountValuePropsDS, 'locale'>

export const AmountValueLocalized = (props: AmountValueLocalizedProps) => {
  const locale = getCurrentLocale()

  return <AmountValue {...props} locale={locale} />
}
